import * as React from "react";
import { IconWrapper } from "common/icons";
import PACKS from "common/icons/packs";
import OverlayTooltip from "common/components/overlayTooltip";
import { Shares } from "common/components/overlayTooltip/preset";
import OutlineButton from "app/common/components/featureButton/preset/outlineButton";

const styles = require("./externalShare.scss");

interface IProps {
  shareUrl: string;
  width: number;
  height: number;
  onClick?: () => void;
}

const ExternalShareButton: React.FC<IProps> = ({
  shareUrl,
  width,
  height,
  onClick,
}) => {
  const [hoverState, setHoverState] = React.useState(false);
  const handleHover = React.useCallback(setHoverState, []);
  const changeableIcon = hoverState
    ? PACKS.ENGAGE.CARD_SHARE_HOVER
    : PACKS.ENGAGE.CARD_SHARE_NORMAL;

  return (
    <OverlayTooltip
      position="right"
      tooltipContent={<Shares shareUrl={shareUrl} />}
    >
      <OutlineButton
        width={width}
        height={height}
        onClick={onClick}
        onHover={handleHover}
      >
        <span className={styles.iconWrapper}>
          <IconWrapper
            tagName="span"
            icon={changeableIcon}
            className={styles.icon}
          />
        </span>
      </OutlineButton>
    </OverlayTooltip>
  );
};

export default ExternalShareButton;
